// ci-redeploy 2026-05-30: no-op to force the pipeline (re-sync deploy to development).
import { startTelemetry } from './telemetry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Wrapper from './app/layout/Wrapper';
import {
    ThemeProvider
} from './shared/components/theme/ThemeProvider';
import {
    BrowserRouter
} from 'react-router-dom';

startTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider defaultTheme="light" storageKey="bex-theme">
        <BrowserRouter>
            {/* <React.StrictMode> */}
            <Wrapper>
                <App />
            </Wrapper>
            {/* </React.StrictMode> */}
        </BrowserRouter>
    </ThemeProvider>
);

reportWebVitals();
